module.exports = __webpack_public_path__ + "img/8.67318415.png";